export default __webpack_public_path__ + "static/media/table4.80f21969.png";